const isText = value => typeof value === "string" && value.trim() !== "";

const toMessage = value => [].concat(value).filter(isText).join(", ") || null;

export const parseApiErrors = (data, fieldNames = []) => {
  const fields = {};
  const globals = [];
  const errors = data?.errors;
  const errorsByKey =
    errors && typeof errors === "object" && !Array.isArray(errors)
      ? errors
      : { global: errors };

  Object.entries(errorsByKey).forEach(([key, value]) => {
    const message = toMessage(value);

    if (!message) return;

    fieldNames.includes(key) ? (fields[key] = message) : globals.push(message);
  });

  if (isText(data?.error)) globals.push(data.error);

  return { fields, global: globals.join(" ") || null };
};
